const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview";
import RankItem from "./rankItem";
import UserDataManager from "../../../../manager/user_manager";
import PlayerIconModule from "../playericon/playerIcon";
import ModuleManager from "../../../../framework/core/module_manager";
import ModelData from "../../../public/model_data";
import PlayerInfoSetting from "../playerInfoSetting/player_info_setting";
import AppData from "../../../public/const/app_data";

@ccclass
export default abstract class RankView extends ViewBase {

    @property(cc.Node)
    mainRank: cc.Node = null

    @property(cc.Node)
    caifuBtnChoose: cc.Node = null

    @property(cc.Node)
    wingoldBtnChoose: cc.Node = null

    @property(cc.ScrollView)
    scrollview: cc.ScrollView = null;

    @property(cc.Node)
    view: cc.Node = null;

    @property(cc.Node)
    content: cc.Node = null;

    @property(cc.Node)
    prefab: cc.Node = null;

    @property(RankItem)
    mySelfItem: RankItem = null

    m_list: ListView = null

    onLoad() {
        let list: ListView = new ListView({
            scrollview: this.scrollview,
            view: this.view,
            content: this.content,
            item_prefab: this.prefab,
            cb_host: this,
            item_update_func: this.update_list_item,
            item_click_ex_func: this.on_item_click,
            column: 1,
            row: 1,
            gap_x: 0,
            gap_y: 10,
            direction: ListViewDir.Vertical,
        });
        this.m_list = list
    }

    on_item_click(data: any) {
        if (data == null) {
            return
        }
        if (ModelData.instance.roleData.id == data.gameUserId) {
            ModuleManager.instance.showModule<PlayerInfoSetting>(PlayerInfoSetting)
        } else {
            if (AppData.startCheckGame) {
                return
            }
            ModuleManager.instance.showModule<PlayerIconModule>(PlayerIconModule, { userId: data.gameUserId, gold: data.val, other: true })
        }
    }


    updateShow(m_Data: any = null, mySelfData = null) {
        if (m_Data == null) {
            m_Data = []
        }
        // if ( m_Data.length < 8){
        //     for (let index = m_Data.length ; index < 7; index++) {
        //         const element = {rank:null}; //设置空数据 处理
        //         m_Data[index] = element
        //     }
        // }
        this.m_list.set_data(m_Data);
        this.m_list.select_item(1)
        this.m_list.scroll_to(0)
        this.mySelfItem.setData(mySelfData, null, true)
    }

    update_list_item(item: cc.Node, data: any, index: number): void {
        let _recordItem = item.getComponent(RankItem)
        _recordItem.setData(data, index)
    }

    changeRankType(showType) {
        this.caifuBtnChoose.active = showType == 1
        this.wingoldBtnChoose.active = showType == 2
    }

}